<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>Not Found</h3>
        <p>Return to the previous page and make the selection manifest again!</p>
        <a-button type="primary" block>
          <router-link to="/umpp">
            <a-icon type="rollback" />&nbsp; Return
          </router-link>
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{span:24}" :lg="{span:16}">
          <a-card :loading="loading">
            <div slot="title">
              UM PP Manifest
              <small class="m-display-block m-text-small">{{data.header.no_um}}</small>
            </div>
            <a-popover slot="extra" trigger="click" placement="bottom">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button
                    @click="handlePrintManifest"
                    type="dashed"
                    icon="printer"
                    block
                    class="m-display-block"
                    :loading="printLoad.manifest"
                  >Manifest</a-button>
                </li>
                <li v-if="getAuth.username == data.header.user_pembuat">
                  <a-button-group>
                    <a-button
                      :disabled="!(data.lastStatus =='Revised' && 
                        getAuth.username == data.header.user_pembuat &&
                        data.revised_flag)"
                      type="dashed"
                      icon="edit"
                      @click="handleEdit"
                    >Edit</a-button>
                    <a-button
                      @click="handlecanceltrans"
                      :disabled="data.header.dana_sts=='1'"
                      type="danger"
                      icon="close-square"
                      :loading="printLoad.cancel"
                    >Cancel</a-button>
                  </a-button-group>
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Created Date</span>
                  <span class="m-list-desc">{{tgl_buat}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Cost Center</span>
                  <span class="m-list-desc">{{data.header.kode_project}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Prepared By</span>
                  <span class="m-list-desc">{{data.header.user_pembuat}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Value</span>
                  <span
                    class="m-list-desc"
                  >{{formatCurrency(data.header.currency,data.header.value_um)}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Exchange Rate</span>
                  <span class="m-list-desc">{{formatRupiah(data.header.kurs)}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Conversion Value</span>
                  <span class="m-list-desc">{{formatRupiah(data.header.konversi)}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Currency</span>
                  <span
                    class="m-list-desc"
                  >{{data.dokumenTerkait[0] ? data.dokumenTerkait[0].currency : ''}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>End User</span>
                  <span class="m-list-desc">{{data.header.end_user}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Description</span>
                  <span class="m-list-desc">{{data.header.deskripsi}}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Note</span>
                  <span class="m-list-desc">{{data.header.catatan=="" ? "-" : data.header.catatan}}</span>
                </li>
              </ul>
            </div>
          </a-card>

          <a-card v-if="getScreen">
            <div slot="title">Details</div>
            <a-list
              itemLayout="vertical"
              :dataSource="initialList.output"
              :pagination="pagination"
            >
              <Empty
                v-if="
                  initialList.output
                    ? initialList.output.length <= 0
                    : initialList.output
                "
              />
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <div slot="title">
                    <span>{{ item.data.nama_barang }}</span><br/>
                    <span>{{ item.data.kode_anggaran }}</span>
                  </div>
                  <div slot="description" class="margin-remove">
                    <div class="m-display-flex space-between">
                      <span
                        >{{ item.data.jumlah_barang }}&nbsp;{{
                          item.data.satuan
                        }}</span
                      >
                      <div>
                        <h4 class="margin-remove m-text-align right">
                          @
                          {{ formatCurrency(data.mata_uang, item.data.harga) }}
                        </h4>
                      </div>
                    </div>
                    <h3 class="margin-remove m-text-align right">
                      Sub Total :
                      {{ formatCurrency(data.mata_uang, item.totalHarga) }}
                    </h3>
                  </div>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
            <div class="m-price-total">
              <a-statistic
                title="Grand Total"
                :value="formatCurrency(data.mata_uang, initialList.grandTotal)"
                class="m-text-align right"
              />
            </div>
          </a-card>
          <a-collapse v-if="!getScreen" class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <h4 slot="header" class="margin-remove">Details</h4>
              <a-input-search
                v-model="search"
                placeholder="Quick Search"
                allowClear
                :change="searching"
                class="margin-bottom"
              />
              <a-table
                :columns="columns"
                :dataSource="tableData"
                :pagination="pagination"
                size="small"
                bordered
                :scroll="{ x: 100 }"
              >
                <div slot="item_nm" slot-scope="item_name">
                  <b>{{item_name.item_nm}}</b>
                </div>
                <div slot="ppdtl" slot-scope="ppdtl">
                  <b>{{ppdtl.nm_barang}}</b><br/>
                  <span>{{ppdtl.kode_anggaran}}</span>
                </div>
                <span slot="unit_price" slot-scope="unit_price">
                  <CurrencyJustified
                    v-if="unit_price.val"
                    :currencyValue="unit_price.curr"
                    :valueNumber="unit_price.val"
                  />
                  <div v-else style="text-align:center;width:100%">-</div>
                </span>
                <span slot="amount" slot-scope="amount">
                  <CurrencyJustified
                    v-if="amount.val"
                    :currencyValue="amount.curr"
                    :valueNumber="amount.val"
                  />
                  <div v-else style="text-align:center;width:100%">-</div>
                </span>
                <div slot="footer" class="padding-all">
                  <a-row type="flex">
                    <a-col :span="5" :order="1" class="m-text-align left"
                      >Grand Total</a-col
                    >
                    <a-col
                      :span="5"
                      :order="2"
                      class="m-text-align left m-text-bold"
                      >{{
                        formatCurrency(
                          data.header.currency,
                          data.header.value_um
                        )
                      }}</a-col
                    >
                  </a-row>
                </div>
              </a-table>
            </a-collapse-panel>
          </a-collapse>

          <template v-if="!getScreen">
            <a-card class="margin-top" v-if="data.jenis === 'Approve' ">
              <a-form :form="form" id>
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan', {rules: [{required: false}], initialValue: catatan }]"
                  />
                </a-form-item>

                <a-form-item label="Status" v-if="data.aksi.length != 0">
                  <a-select
                    showSearch
                    v-decorator="['status', {rules: [{required: true}], initialValue: data.aksi[0].aksi }]"
                  >
                    <a-select-option v-for="da in data.aksi" :key="da.aksi">{{da.aksi}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-form>
              <template class="ant-card-actions" slot="actions">
                <div class="steps-action">
                  <a-button type="primary" html-type="submit" block @click="submit">Save</a-button>
                </div>
              </template>
            </a-card>

            <a-card class="margin-top" v-else-if="data.jenis === 'Verifikator' ">
              <a-form :form="form" id>
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan', {rules: [{required: false}], initialValue: catatan }]"
                  />
                </a-form-item>

                <a-form-item label="Status">
                  <a-select
                    showSearch
                    v-decorator="['status', {rules: [{required: true}], initialValue: data.aksi[0].aksi }]"
                  >
                    <a-select-option v-for="da in data.aksi" :key="da.aksi">{{da.aksi}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-form>
              <template class="ant-card-actions" slot="actions">
                <div class="steps-action">
                  <a-button type="primary" html-type="submit" block @click="submit">Save</a-button>
                </div>
              </template>
            </a-card>

            <a-card class="margin-top" v-else-if="data.jenis === 'Transfer' ">
              <div slot="title">Manifest Actions
                &nbsp;<i v-if="data.jenis=='Transfer' && !data.status_transfer" style="color:red!important">(Funding has not been set)</i>
              </div>
              <div class="m-text-align right margin-remove" slot="extra">
                <h5 class="m-text-align right margin-remove">remaining balance</h5>
                <a-tag
                  color="green"
                  class="m-text-align right margin-remove"
                >{{formatCurrency(data.header.currency,sisa_tf)}}</a-tag>
              </div>
              <template v-if="!(data.jenis=='Transfer' && !data.status_transfer)">
                <a-form :form="form" id>
                  <a-form-item label="Status">
                    <a-select
                      @change="onChangeStatus"
                      v-decorator="['status', {rules: [{required: true}], initialValue: data.aksi[0].aksi }]"
                    >
                      <a-select-option v-for="da in data.aksi" :key="da.aksi">{{da.aksi}}</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item
                    label="Transfer Date"
                    v-if="aksiSelected === 'Transferred' || aksiSelected === ''"
                  >
                    <a-date-picker
                      placeholder="Select Date"
                      :format="dateFormat"
                      v-decorator="['tgl_tf', {rules: [{required: true}], initialValue:tglTf }]"
                    />
                  </a-form-item>

                  <a-form-item
                    label="Upload Bukti Transfer"
                    v-if="aksiSelected === 'Transferred' || aksiSelected === ''"
                  >
                    <a-upload
                      :fileList="fileList"
                      :disabled="fileList.length >0"
                      v-decorator="['file_transfer', {rules: [{required: true}]}]"
                      accept=".jpg, .png, .pdf"
                      :remove="handleRemove"
                      :beforeUpload="beforeUpload"
                    >
                      <a-button>
                        <a-icon type="upload" />Select File
                      </a-button>
                    </a-upload>
                  </a-form-item>

                  <a-form-item
                    label="Transfer Value "
                    v-if="aksiSelected === 'Transferred' || aksiSelected === ''"
                  >
                    <a-checkbox
                      :defaultChecked="true"
                      @change="onchangeNilaiTf"
                      :checked="checkTransferValue"
                    >Transfer value according to remaining balance</a-checkbox>
                    <a-input-number
                      :min="1"
                      :max="sisa_tf"
                      class="m-width-full m-text-align right"
                      v-decorator="['value_transferan', {rules: [{required: true}],initialValue: sisa_tf}]"
                      :disabled="disableNilaiTf"
                    ></a-input-number>
                  </a-form-item>

                  <a-form-item label="Note">
                    <a-textarea
                      placeholder="Write the note here ... "
                      :rows="4"
                      v-decorator="['catatan', {rules: [{required: false}], initialValue: catatan }]"
                    />
                  </a-form-item>
                </a-form>
                <template class="ant-card-actions" slot="actions">
                  <div class="steps-action">
                    <a-button type="primary" html-type="submit" block @click="submit">Save</a-button>
                  </div>
                </template>
              </template>
            </a-card>

            <a-card class="margin-top" v-else-if="data.jenis === 'Transferred' ">
              <a-form :form="form">
                <a-form-item label="Status">
                  <a-select
                    @change="onChangeStatus"
                    v-decorator="['status', {rules: [{required: true}], initialValue: data.aksi[0].aksi }]"
                  >
                    <a-select-option v-for="da in data.aksi" :key="da.aksi">{{da.aksi}}</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="Transfer Date">
                  <a-date-picker
                    placeholder="Select Date"
                    :format="dateFormat"
                    v-decorator="['tgl_tf', {rules: [{required: true}], initialValue:tglTf }]"
                  />
                </a-form-item>

                <a-form-item label="Upload Bukti Transfer">
                  <a-upload
                    :fileList="fileList"
                    :disabled="fileList.length >0"
                    v-decorator="['file_transfer', {rules: [{required: true}]}]"
                    accept=".jpg, .png, .pdf"
                    :remove="handleRemove"
                    :beforeUpload="beforeUpload"
                  >
                    <a-button>
                      <a-icon type="upload" />Select File
                    </a-button>
                  </a-upload>
                </a-form-item>

                <a-form-item label="Transfer Value">
                  <a-checkbox
                    :defaultChecked="true"
                    @change="onchangeNilaiTf"
                    :checked="checkTransferValue"
                  >Transfer value according to remaining balance</a-checkbox>
                  <br />
                  <a-input-number
                    :min="1"
                    :max="sisa_tf"
                    class="m-width-full m-text-align right"
                    v-decorator="['value_transferan', {rules: [{required: true}],initialValue: temp_sisa_tf}]"
                    :disabled="disableNilaiTf"
                  ></a-input-number>
                </a-form-item>

                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan', {rules: [{required: false}], initialValue: catatan }]"
                  />
                </a-form-item>
              </a-form>
              <template class="ant-card-actions" slot="actions">
                <div class="steps-action">
                  <a-button type="primary" html-type="submit" block @click="submit">Save</a-button>
                </div>
              </template>
            </a-card>
          </template>
        </a-col>
        <a-col :xs="{span:24}" :lg="{span:8}">
          <a-collapse
            :class="getScreen ? 'margin-top' : 'margin-bottom'"
            :activeKey="!getScreen ? 1 : 0"
          >
            <a-collapse-panel key="1">
              <div class="m-display-flex space-between align-middle" slot="header">
                <h4 class="margin-remove">Transfer Receipt</h4>
              </div>
              <ul class="m-list-wrapper bordered">
                <li v-for="(dbt) in data.detailBuktiTransfer" :key="dbt.id_file_um">
                  <h3
                    class="margin-remove m-list-title"
                  >{{moment(dbt.tgl_tf).format(getDefaultDateFormat)}} | {{dbt.user_tf}}</h3>
                  <div class="m-display-flex space-between align-middle">
                    <h3
                      class="margin-remove m-list-title"
                    >{{formatCurrency(dbt.currency, dbt.value_tf)}}</h3>
                    <a-upload
                      class="upload-custom"
                      :fileList="dbt.fileList"
                      @preview="handlePreview"
                    ></a-upload>
                    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                      <div class="margin-top"></div>
                      <a-divider class="margin-small" />
                      <img alt="example" style="width: 100%" :src="previewImage" />
                    </a-modal>
                  </div>
                </li>
              </ul>
            </a-collapse-panel>
          </a-collapse>
          <a-collapse :class="getScreen ? 'margin-top' : ''" :activeKey="!getScreen ? 1 : 0">
            <a-collapse-panel key="1">
              <div class="m-display-flex space-between align-middle" slot="header">
                <h4 class="margin-remove">Transaction Status</h4>
                <div>
                  <Status :status="data.lastStatus" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="undo" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">Creator - {{data.header.user_pembuat}}</div>
                  <div class="m-timeline-body">
                    <h4
                      class="margin-remove"
                    >{{moment(data.header.tgl_buat).format(getDateTimeFormat)}}</h4>
                    <span class="m-text-small" v-if="data.header.catatan">{{data.header.catatan}}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  color="green"
                  v-for="(workflow,i) in data.workflowStatus"
                  :key="workflow.step_no"
                >
                  <div class="m-timeline-title">{{workflow.actor}} - {{workflow.tlc}}</div>
                  <div class="m-timeline-body">
                    <h4
                      class="margin-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >{{moment(workflow.tanggal_aksi).format(getDateTimeFormat)}}</h4>
                    <span class="m-text-small" v-if="workflow.remark">{{workflow.remark}}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div class="m-display-flex space-between align-middle" slot="header">
                <h4 class="margin-remove">Related Document</h4>
              </div>

              <a-list itemLayout="horizontal" :dataSource="data.dokumenTerkait">
                <Empty
                  v-if="data.dokumenTerkait ? data.dokumenTerkait.length<=0 : data.dokumenTerkait"
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between align-middle">
                      <a @click="handleView(item)">{{item.header}} | {{item.tlc}}</a>
                      <Status :class="!getScreen ? 'margin-remove' : ''" :status="item.status" />
                    </div>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                      v-if="item.no_manifest"
                    >
                      <span>{{item.no_manifest}}</span>
                    </div>
                    <div slot="description" v-if="item.tgl_mulai_dinas">
                      <span>{{moment(item.tgl_mulai_dinas,getStandartFormatDate).format(getDefaultDateFormat)}} - {{moment(item.tgl_selesai_dinas,getStandartFormatDate).format(getDefaultDateFormat)}}</span>
                    </div>
                    <div slot="description">
                      <div class="m-width-full">
                        <a-tooltip
                          class="ant-tooltip-inner"
                          placement="top"
                          :title="item.deskripsi ? item.deskripsi : 'Tidak ada deskripsi'"
                        >
                          <span
                            class="ant-description-ellipses"
                          >{{item.deskripsi ? item.deskripsi : 'Tidak ada deskripsi'}}</span>
                        </a-tooltip>
                      </div>
                    </div>
                    <div slot="title" v-if="item.value_transaksi">
                      <span
                        class="m-timeline-title"
                      >{{formatCurrency(item.currency,item.value_transaksi)}}</span>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
      <template v-if="getScreen">
        <a-card class="margin-top" v-if="data.jenis === 'Approve' ">
          <a-form :form="form" id>
            <a-row :gutter="16">
              <a-col :xs="{span:24}" :lg="{span:8}">
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan', {rules: [{required: false}], initialValue: catatan }]"
                  />
                </a-form-item>

                <a-form-item label="Status" v-if="data.aksi.length != 0">
                  <a-select
                    showSearch
                    v-decorator="['status', {rules: [{required: true}], initialValue: data.aksi[0].aksi }]"
                  >
                    <a-select-option v-for="da in data.aksi" :key="da.aksi">{{da.aksi}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
          <template class="ant-card-actions" slot="actions">
            <div class="steps-action">
              <a-button type="primary" html-type="submit" block @click="submit">Save</a-button>
            </div>
          </template>
        </a-card>

        <a-card class="margin-top" v-else-if="data.jenis === 'Verifikator' ">
          <a-form :form="form" id>
            <a-row :gutter="16">
              <a-col :xs="{span:24}" :lg="{span:8}">
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan', {rules: [{required: false}], initialValue: catatan }]"
                  />
                </a-form-item>

                <a-form-item label="Status">
                  <a-select
                    showSearch
                    v-decorator="['status', {rules: [{required: true}], initialValue: data.aksi[0].aksi }]"
                  >
                    <a-select-option v-for="da in data.aksi" :key="da.aksi">{{da.aksi}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
          <template class="ant-card-actions" slot="actions">
            <div class="steps-action">
              <a-button type="primary" html-type="submit" block @click="submit">Save</a-button>
            </div>
          </template>
        </a-card>

        <a-card class="margin-top" v-else-if="data.jenis === 'Transfer' ">
          <div slot="title">Manifest Actions
            &nbsp;<i v-if="data.jenis=='Transfer' && !data.status_transfer" style="color:red!important">(Funding has not been set)</i>
          </div>
          <div class="m-text-align right margin-remove" slot="extra">
            <h5 class="m-text-align right margin-remove">remaining balance</h5>
            <a-tag
              color="green"
              class="m-text-align right margin-remove"
            >{{formatCurrency(data.header.currency,sisa_tf)}}</a-tag>
          </div>
          <template v-if="!(data.jenis=='Transfer' && !data.status_transfer)">
            <a-form :form="form" id>
              <a-row :gutter="16">
                <a-col :xs="{span:24}" :lg="{span:8}">
                  <a-form-item label="Status">
                    <a-select
                      @change="onChangeStatus"
                      v-decorator="['status', {rules: [{required: true}], initialValue: data.aksi[0].aksi }]"
                    >
                      <a-select-option v-for="da in data.aksi" :key="da.aksi">{{da.aksi}}</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item
                    label="Transfer Date"
                    v-if="aksiSelected === 'Transferred' || aksiSelected === ''"
                  >
                    <a-date-picker
                      placeholder="Select Date"
                      :format="dateFormat"
                      v-decorator="['tgl_tf', {rules: [{required: true}], initialValue:tglTf }]"
                    />
                  </a-form-item>

                  <a-form-item
                    label="Upload Bukti Transfer"
                    v-if="aksiSelected === 'Transferred' || aksiSelected === ''"
                  >
                    <a-upload
                      :fileList="fileList"
                      :disabled="fileList.length >0"
                      v-decorator="['file_transfer', {rules: [{required: true}]}]"
                      accept=".jpg, .png, .pdf"
                      :remove="handleRemove"
                      :beforeUpload="beforeUpload"
                    >
                      <a-button>
                        <a-icon type="upload" />Select File
                      </a-button>
                    </a-upload>
                  </a-form-item>

                  <a-form-item
                    label="Transfer Value"
                    v-if="aksiSelected === 'Transferred' || aksiSelected === ''"
                  >
                    <a-checkbox
                      :defaultChecked="true"
                      @change="onchangeNilaiTf"
                      :checked="checkTransferValue"
                    >Transfer value according to remaining balance</a-checkbox>
                    <a-input-number
                      :min="1"
                      :max="sisa_tf"
                      class="m-width-full m-text-align right"
                      v-decorator="['value_transferan', {rules: [{required: true}],initialValue: sisa_tf}]"
                      :disabled="disableNilaiTf"
                    ></a-input-number>
                  </a-form-item>

                  <a-form-item label="Note">
                    <a-textarea
                      placeholder="Write the note here ... "
                      :rows="4"
                      v-decorator="['catatan', {rules: [{required: false}], initialValue: catatan }]"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
            <template class="ant-card-actions" slot="actions">
              <div class="steps-action">
                <a-button type="primary" html-type="submit" block @click="submit">Save</a-button>
              </div>
            </template>
          </template>
        </a-card>

        <a-card class="margin-top" v-else-if="data.jenis === 'Transferred' ">
          <a-form :form="form">
            <a-row :gutter="16">
              <a-col :xs="{span:24}" :lg="{span:8}">
                <a-form-item label="Status">
                  <a-select
                    @change="onChangeStatus"
                    v-decorator="['status', {rules: [{required: true}], initialValue: data.aksi[0].aksi }]"
                  >
                    <a-select-option v-for="da in data.aksi" :key="da.aksi">{{da.aksi}}</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="Transfer Date">
                  <a-date-picker
                    placeholder="Select Date"
                    :format="dateFormat"
                    v-decorator="['tgl_tf', {rules: [{required: true}], initialValue:tglTf }]"
                  />
                </a-form-item>

                <a-form-item label="Upload Bukti Transfer">
                  <a-upload
                    :fileList="fileList"
                    :disabled="fileList.length >0"
                    v-decorator="['file_transfer', {rules: [{required: true}]}]"
                    accept=".jpg, .png, .pdf"
                    :remove="handleRemove"
                    :beforeUpload="beforeUpload"
                  >
                    <a-button>
                      <a-icon type="upload" />Select File
                    </a-button>
                  </a-upload>
                </a-form-item>

                <a-form-item label="Transfer Value">
                  <a-checkbox
                    :defaultChecked="true"
                    @change="onchangeNilaiTf"
                    :checked="checkTransferValue"
                  >Transfer value according to remaining balance</a-checkbox>
                  <br />
                  <a-input-number
                    :min="1"
                    :max="sisa_tf"
                    class="m-width-full m-text-align right"
                    v-decorator="['value_transferan', {rules: [{required: true}],initialValue: temp_sisa_tf}]"
                    :disabled="disableNilaiTf"
                  ></a-input-number>
                </a-form-item>

                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan', {rules: [{required: false}], initialValue: catatan }]"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
          <template class="ant-card-actions" slot="actions">
            <div class="steps-action">
              <a-button type="primary" html-type="submit" block @click="submit">Save</a-button>
            </div>
          </template>
        </a-card>
      </template>
    </div>
    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title">
        <a-icon type="reload" />&nbsp;History Status
      </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">{{history.as_from}} | {{history.tlc_from}}</h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{moment(history.tgl_notif).format(getDateTimeFormat)}}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >{{history.as_from}} | {{history.tlc_from}}</h3>
              <h3 class="margin-remove m-list-title" v-else>{{history.as_to}} | {{history.tlc_to}}</h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{moment(history.tgl_notif).format(getDateTimeFormat)}}</span>
          </div>
        </li>
      </ul>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import lottie from "vue-lottie";
import notfound from "@/assets/anim/notfound.json";
import Status from "@/components/Status.vue";
import axios from "axios";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";

export default {
  name: "UmppManifest",
  props: ["id", "user_pembuat"],
  components: { "m-anim": lottie, Status },
  mixins: [CurrencyFormat, HandleRoute],
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getDateTimeFormat",
      "getIsSpecialMenu",
      "getStandartFormatDate",
      "getDefaultDateFormat",
      "getDateTimeFormat"
    ]),
    initialList() {
      let totalHarga = 0;
      let grandTotal = 0;
      let output = [];
      this.data.detail.forEach((data) => {
        totalHarga = Number(data.harga) * Number(data.jumlah_barang);
        grandTotal = grandTotal + totalHarga;
        output = [...output, { data: data, totalHarga: totalHarga }];
      });

      return { output, grandTotal };
    },
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 50,
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "Item Name",
          width: 100,
          scopedSlots: { customRender: "item_nm" },
          key: "item_nm",
          sorter: (a, b) => a.item_nm.length - b.item_nm.length,
        },
        {
          title: "PP Detail",
          width: 100,
          scopedSlots: { customRender: "ppdtl" },
          key: "ppdtl",
          sorter: (a, b) => a.nm_barang.length - b.nm_barang.length,
        },
        {
          title: "Unit Price",
          dataIndex: "unit_price",
          key: "unit_price",
          width: 100,
          scopedSlots: { customRender: "unit_price" },
        },
      ];
      return kolom;
    },

    searching() {
      if (this.search) {
        this.tableData = this.tableDataTemp;
        this.tableData = this.tableData.filter(
          (obj) =>
            obj.item_nm.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.nm_barang.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.kode_anggaran.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (!this.search) {
        this.tableData = this.tableDataTemp;
      }

      return this.tableData;
    },
  },
  created() {
    this.fetchManifest(this.id);
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest(this.id);
        this.form = this.$form.createForm(this);
        this.fileList = [];
        this.checkTransferValue = true;
        this.cek_value = 0;
        this.disableNilaiTf = true;
        this.aksiSelected = "Transferred";
      }
    },
  },
  data() {
    return {
      printLoad: {
        manifest: false,
        cancel: false,
      },
      form: this.$form.createForm(this),
      previewVisible: false,
      previewImage: "",
      loading: true,
      notfound: { animationData: notfound, loop: true },
      id_um: this.id,
      dateFormat: "DD MMMM YYYY",
      tgl_buat: "",
      disableNilaiTf: true,
      data: {
        header: [],
        dokumenTerkait: [],
        detailBuktiTransfer: [],
        tgl_bukti_transfer: [],
        dateFormatTf: "DD-MM-YYYY",
        tgl_dokumen: [],
        lastStatus: "",
        mengetahui: [],
        history: [],
        workflowStatus: [],
        jenis: "",
        aksi: [],
        status_transfer: true
      },
      visibleHistory: false,
      catatan: "",
      postData: new FormData(),
      tglTf: moment(new Date()),
      cek_value: 1,
      fileList: [],
      uploading: false,
      // reqFileTf: true,
      sisa_tf: "",
      temp_sisa_tf: "",
      aksiSelected: "",
      checkTransferValue: true,
      search: "",
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
      tableData: [],
      tableDataTemp: [],
    };
  },
  methods: {
    moment,
    fetchManifest(idValue) {
      this.loading = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "um_pp",
        params: {
          user_pembuat: this.user_pembuat,
          tlc: this.getAuth.username,
          id_manifest: idValue,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.id = response.data.header[0].id_um;
          this.data.status_transfer = response.data.status_transfer,
          this.data.header = response.data.header[0];
          this.data.detail = response.data.detail;
          this.tgl_buat = moment(response.data.header[0].tgl_buat).format(
            this.dateFormat
          );
          this.data.dokumenTerkait = response.data.dokumen_terkait;
          this.data.tgl_dokumen.push(
            moment(response.data.dokumen_terkait[0].tgl).format(this.dateFormat)
          );
          this.data.lastStatus = response.data.last_status;
          this.data.detailBuktiTransfer = response.data.detail_bukti_transfer;

          this.data.history = response.data.notifikasi;
          this.data.workflowStatus = response.data.status_app;
          this.data.jenis = response.data.jenis;
          this.data.aksi = response.data.aksi;
          this.data.revised_flag = response.data.header[0].revised_flag == "1" ? true : false;
          this.loading = false;

          let dbt = this.data.detailBuktiTransfer;
          for (const [i, val] of dbt.entries()) {
            let name = i + 1 + val.url.substring(val.url.lastIndexOf("."));
            this.data.detailBuktiTransfer[i]["fileList"] = [
              {
                url: process.env.VUE_APP_SERVICEURL + val.url,
                uid: val.id_file_um,
                name: name,
                status: "done",
              },
            ];
            this.data.tgl_bukti_transfer.push(
              moment(val.tgl_tf).format(this.data.dateFormatTf)
            );
          }

          this.sisa_tf = response.data.sisa_tf;
          this.temp_sisa_tf = this.sisa_tf;

          if (!this.getScreen) {
            let dataPemakaian = response.data.detail;
            response.data.detail.forEach((value, index) => {
              dataPemakaian[index]["no"] = index + 1;
              dataPemakaian[index]["key"] = index + 1;
              dataPemakaian[index]["kode_anggaran"] = value.kode_anggaran;
              dataPemakaian[index]["item_nm"] = value.item_nm;
              dataPemakaian[index]["nm_barang"] = value.nm_barang;
              dataPemakaian[index]["unit_price"] = {
                curr: response.data.currency,
                val: Number(value.value),
              };
            });

            this.tableData = dataPemakaian;
            this.tableDataTemp = dataPemakaian;
          }
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-getdetil");
            this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.$router.push({ name: "beranda" });
          }
        });
    },
    submit() {
      this.confirmMessage("confirm-save");
    },
    submitProcess() {
      if (this.data.jenis === "Approve") {
        this.form.validateFields((err, values) => {
          if (err) {
            return;
          }
          this.postData = new FormData();
          this.postData.append("tlc", this.getAuth.username);
          this.postData.append("id_manifest", this.id);
          this.postData.append(
            "remark",
            values.catatan !== undefined ? values.catatan : ""
          );
          this.postData.append("status", values.status);

          axios({
            method: "post",
            url: this.$serviceUrl + "um_pp/approval",

            data: this.postData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success-edit");
              this.$router.go(0);
              /* this.$router.push({ name: "ListUmPp" }); */
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        });
      } else if (this.data.jenis === "Transfer") {
        this.form.validateFields((err, values) => {
          if (err) {
            return;
          }
          this.postData = new FormData();

          if (values.status === "Revised") {
            this.postData.append("tlc", this.getAuth.username);
            this.postData.append("id_manifest", this.id);
            this.postData.append(
              "remark",
              values.catatan !== undefined ? values.catatan : ""
            );
            this.postData.append("status", values.status);
            // this.postData.append("cek_value", this.cek_value);
            // this.postData.append("value_transfer", values.value_transferan);
            // this.postData.append(
            //   "tgl_transfer",
            //   values.tgl_tf.format("YYYY-MM-DD")
            //   // moment(values.tgl_tf).format(this.dateFormat)
            // );
          } else if (values.status === "Transferred") {
            this.postData.append("tlc", this.getAuth.username);
            this.postData.append("id_manifest", this.id);
            this.postData.append(
              "remark",
              values.catatan !== undefined ? values.catatan : ""
            );
            this.postData.append("status", values.status);
            this.postData.append("cek_value", this.cek_value);
            this.postData.append("value_transfer", values.value_transferan);
            this.postData.append("file_transfer", values.file_transfer.file);
            this.postData.append(
              "tgl_transfer",
              values.tgl_tf.format("YYYY-MM-DD")
              // moment(values.tgl_tf).format(this.dateFormat)
            );
          }

          // console.log(values.file_transfer);
          axios({
            method: "post",
            url: this.$serviceUrl + "um_pp/approval",

            data: this.postData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success-send");
              this.$router.go(0);
              /* this.$router.push({ name: "ListUmPp" }); */
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        });
      } else if (this.data.jenis === "Verifikator") {
        this.form.validateFields((err, values) => {
          if (err) {
            return;
          }
          this.postData = new FormData();
          this.postData.append("tlc", this.getAuth.username);
          this.postData.append("id_manifest", this.id);
          this.postData.append(
            "remark",
            values.catatan !== undefined ? values.catatan : ""
          );
          this.postData.append("status", values.status);

          axios({
            method: "post",
            url: this.$serviceUrl + "um_pp/approval",

            data: this.postData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success-edit");
              this.$router.go(0);
              /* this.$router.push({ name: "ListUmPp" }); */
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        });
      } else if (this.data.jenis === "Transferred") {
        this.form.validateFields((err, values) => {
          if (err) {
            return;
          }

          this.postData = new FormData();
          this.postData.append("tlc", this.getAuth.username);
          this.postData.append("id_manifest", this.id);
          this.postData.append(
            "remark",
            values.catatan !== undefined ? values.catatan : ""
          );
          this.postData.append("status", values.status);
          this.postData.append("cek_value", this.cek_value);
          this.postData.append("value_transferan", values.value_transferan);
          this.postData.append("file_transfer", values.file_transfer.file);
          this.postData.append(
            "tgl_tf",
            moment(values.tgl_tf).format(this.dateFormat)
          );

          axios({
            method: "post",
            url: this.$serviceUrl + "um_pp/approval",

            data: this.postData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success-edit");
              this.$router.go(0);
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        });
      }
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    handlePreview(file) {
      if (file.url.substr(file.url.length - 3) === "pdf") {
        window.open(file.url, "_blank");
      } else {
        this.previewImage = file.url || file.thumbUrl;
        this.previewVisible = true;
      }
    },
    handleCancel() {
      this.previewVisible = false;
    },
    onchangeNilaiTf(e) {
      this.disableNilaiTf = e.target.checked;
      if (e.target.checked) {
        this.cek_value = 1;
        this.checkTransferValue = true;
        this.form.setFieldsValue({ value_transferan: this.sisa_tf });
      } else {
        this.cek_value = 0;
        this.checkTransferValue = false;
      }
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 2) {
        this.displayMessage("large-file-2mb");
      } else {
        this.fileList.push(file);
        return false;
      }
    },
    onChangeStatus(item) {
      this.aksiSelected = item;
      if (item === "Revised") {
        this.fileList = [];
      } else {
        this.checkTransferValue = true;
        this.cek_value = 0;
        this.disableNilaiTf = true;
        this.form.setFieldsValue({ value_transferan: this.sisa_tf });
      }
    },
    handlePrintManifest() {
      this.printLoad.manifest = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "um_pp/cetak_um_pp",
        responseType: "blob",
        params: {
          id_um: this.id,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoad.manifest = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad.manifest = false;
          this.$router.go(-1);
        });
    },
    handlecanceltrans() {
      this.confirmMessageValue("confirm-cancel", null, null);
    },
    canceltrans() {
      this.printLoad.cancel = true;

      const data = {
        tlc: this.getAuth.username,
        jenis_trans: "umpp",
        id_manifest: this.id,
        code_trans: this.data.header.no_um,
        kode_project: this.data.header.kode_project,
      };
      this.$store
        .dispatch("cancelTransaction", { auth: this.getAuth, data: data })
        .then((response) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("successCancel", response.data.message);
          this.$router.go();
        })
        .catch((error) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("error", error.message);
        });
    },
    handleEdit() {
      this.$router.push({
        name: "UmppEdit",
        params: { id: this.id, type: "revised" },
      });
    },
  },
  mounted() {
    if (this.data.jenis === "Approve") {
      this.status = "Revise";
    }
    // this.fetchManifest(this.id);
    Event.$on("confirmMessageReturn", this.submitProcess);
    Event.$on("handleCancel", this.canceltrans);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.submitProcess);
    Event.$off("handleCancel", this.canceltrans);
  },
};
</script>

<style lang="less" scoped>
</style>